{
  "language": {
    "label": "Language"
  },
  "common": {
    "next": "Next",
    "previous": "Previous",
    "cancel": "Cancel",
    "save": "Save",
    "finish": "Finish",
    "loading": "Loading...",
    "home": "Home",
    "numbersOnly": "Enter numbers only",
    "cancelRegistration": "Cancel registration",
    "smartdocsPortal": "@ Smartdocs Portal",
    "noVersionInfo": "No system version information available.",
    "portalDeServicos": "Services Portal",
    "catalog": "Catalog",
    "requests": "Requests"
  },
  "login": {
    "title": "Sign in to Services Portal",
    "passwordLabel": "Password *",
    "saveCredentials": "Save credentials for future access",
    "recaptchaError": "Could not validate your submission. Please refresh the page and try again.",
    "submitting": "Signing in...",
    "submit": "Sign in with CPF",
    "forgotPassword": "Forgot password",
    "noAccount": "I don't have an account yet",
    "loginError": "Login error.",
    "loginErrorTitle": "Login error:",
    "tooManyAttempts": "Multiple incorrect login attempts. Your access has been temporarily blocked for 15 minutes."
  },
  "forgotPassword": {
    "title": "Forgot password",
    "submitButton": "SEND RESET LINK",
    "successTitle": "Password reset link sent successfully!",
    "successMessage": "A link to create a new password has been sent to the registered email.",
    "registeredEmailLabel": "Registered email *",
    "accessEmail": "Check this email to make the change."
  },
  "resetPassword": {
    "title": "Create new password",
    "subtitle": "What password would you like to use to access the portal?",
    "keepPassword": "Keep your password in a safe and accessible place.",
    "keepPasswordTypo": "Keep your password in a safe and accessible place.",
    "passwordLabel": "Password *",
    "confirmPasswordLabel": "Repeat Password *",
    "saveButton": "Save new password",
    "successTitle": "Password changed successfully!",
    "expiredTitle": "The link has expired!",
    "expiredMessage": "The password reset link has expired.",
    "requestNewLink": "Request a new reset link.",
    "enterPortal": "Access the portal"
  },
  "emailValidation": {
    "accountReady": "Your account is ready to use!",
    "emailMainChannel": "Email is the primary communication channel between the Portal and you.",
    "checkInbox": "Check your inbox regularly.",
    "enterPortal": "ACCESS THE PORTAL",
    "validateEmail": "Validate your email to unlock access.",
    "requestNewLink": "Request a new validation link.",
    "emailNotValidated": "Your email has not been validated yet.",
    "indispensableStep": "This step is essential to unlock your access to the portal.",
    "resendButton": "RESEND VALIDATION EMAIL",
    "linkExpires": "The email link expires in 1 hour.",
    "linkSentSuccess": "Link sent successfully!",
    "almostThere": "We're almost there!",
    "accessEmailToValidate": "Access the email sent by the Portal and open the validation link to activate your account.",
    "indispensableStepPortal": "This step is essential to unlock your access to the portal.",
    "accessRegistrationEmail": "Access the email used during registration and complete the validation."
  },
  "register": {
    "createAccount": "Create account",
    "abandonTitle": "Do you want to abandon the registration?",
    "abandonMessage": "By leaving, you will lose all data entered so far.",
    "continueRegistering": "Continue registering",
    "exitRegistration": "Exit registration",
    "steps": {
      "cpf": "What is your CPF?",
      "fullName": "What is your full name?",
      "contacts": "What are your contact details?",
      "address": "What is your address?",
      "password": "What password would you like to use to access the portal?"
    },
    "cpfAlreadyRegistered": "The CPF entered is already registered. Please enter a different CPF.",
    "serviceUnavailable": "Service unavailable, please try again later.",
    "fullNameLabel": "Full name *",
    "fullNamePlaceholder": "First Last",
    "emailLabel": "Email *",
    "emailHelperText": "Choose an email address you can easily access.",
    "confirmEmailLabel": "Repeat email *",
    "confirmEmailHelperText": "The email must be identical to the one entered above.",
    "confirmPasswordLabel": "Repeat password *",
    "confirmPasswordHelperText": "The password must be identical to the one entered above.",
    "acceptTerms": "I accept the",
    "consentTerms": "Terms of Consent",
    "cepRequired": "ZIP code is required to proceed.",
    "cepDigits": "ZIP code must have 8 digits to proceed.",
    "cepInvalid": "Invalid ZIP code. You can fill in the address manually.",
    "ufLabel": "State",
    "cityLabel": "City *",
    "neighborhoodLabel": "Neighborhood *",
    "streetLabel": "Street *",
    "streetNumberLabel": "Number *",
    "complementLabel": "Complement",
    "cellphoneLabel": "Mobile phone *",
    "phoneLabel": "Landline",
    "returnSuccess": {
      "title": "Account created successfully!",
      "almostThere": "We're almost there!",
      "emailSent": "An email has been sent to the email address provided during account creation.",
      "emailLabel": "Provided email *",
      "validateAccess": "Access this email to validate your registration and access the portal.",
      "redirecting": "Redirecting in {{countdown}} sec or",
      "clickHere": "click here."
    },
    "returnError": {
      "title": "Choose another email for registration",
      "message": "We could not send the validation link to the provided email",
      "emailLabel": "Provided email *",
      "chooseAnother": "Choose <b>another</b> <b>email</b> address that you have <b>easy access</b> to.",
      "emailFieldLabel": "Email *",
      "confirmEmailLabel": "Repeat email *"
    }
  },
  "home": {
    "catalog": "Catalog",
    "requests": "Requests",
    "noRequests": "You haven't made any requests yet.",
    "noCategory": "No category found.",
    "noOrganization": "No organization found.",
    "noService": "No service found.",
    "others": "Others",
    "startRequest": "Start request",
    "searchPlaceholder": "Find a request",
    "searchTitle": "Track your requests",
    "searchOrganizationPlaceholder": "Find an organization",
    "searchOrganizationTitle": "Choose an organization",
    "searchCategoryPlaceholder": "Find a category",
    "searchCategoryTitle": "Choose a category",
    "searchServicePlaceholder": "Find a service",
    "searchServiceTitle": "Choose a service",
    "noTaskFound": "No task found"
  },
  "myAccount": {
    "title": "My account",
    "fullNameLabel": "Full name",
    "cpfLabel": "CPF",
    "editPassword": "Edit password",
    "logout": "Sign out",
    "logoutDialogTitle": "Disconnect from portal?",
    "logoutDialogMessage": "Sign out safely.",
    "logoutButton": "Disconnect",
    "stayButton": "Stay on Portal",
    "deactivateAccount": "Deactivate account",
    "deactivateModalTitle": "Permanently deactivate account",
    "deactivateModalWarning": "Warning: this action is irreversible. Deactivating your account will delete your personal data and you will no longer be able to access the portal with this registration.",
    "deactivateModalSubtitle": "Please provide the reason and your password to confirm permanent account deactivation.",
    "deactivationReasonLabel": "Deactivation reason *",
    "deactivationReasonPlaceholder": "Describe the reason for deactivation...",
    "deactivationPasswordLabel": "Your current password *",
    "proceedButton": "Proceed",
    "confirmDeactivationButton": "Confirm deactivation",
    "deactivatingButton": "Deactivating...",
    "deactivateSuccess": "Account successfully deactivated.",
    "deactivateErrorTitle": "Failed to deactivate account",
    "deactivateError": "Error deactivating account. Please check your password and try again."
  },
  "editPassword": {
    "breadcrumb": "My account",
    "title": "Edit password",
    "currentPasswordLabel": "Current password *",
    "passwordLabel": "Password *",
    "confirmPasswordLabel": "Repeat new password *",
    "cancelButton": "Cancel",
    "saving": "Saving...",
    "saveButton": "Save changes",
    "successMessage": "Password updated successfully!",
    "errorMessage": "Error updating password. Please try again.",
    "incorrectPassword": "The password is incorrect."
  },
  "requestHistory": {
    "breadcrumbRequests": "Requests",
    "historyTitle": "Request history",
    "stepsTab": "Steps",
    "documentsTab": "Documents",
    "orderByLabel": "Order by",
    "mostRecent": "Most recent",
    "oldest": "Oldest",
    "documentsLoadError": "Error loading documents.",
    "noDocuments": "The process does not have documents yet.",
    "processStarted": "Process started",
    "inProgress": "In progress",
    "completed": "Completed"
  },
  "signature": {
    "signSuccess": "Document(s) signed successfully!",
    "signError": "Error signing document(s): ",
    "otpResent": "OTP resent.",
    "otpResendError": "Error resending OTP:",
    "modalTitle": "Sign selected document(s)",
    "modalDescription": "Use the code received via email to sign the document(s).",
    "emailLabel": "Email *",
    "codeLabel": "Code *",
    "codePlaceholder": "Code",
    "signAndSend": "Sign and submit",
    "returnToDocuments": "Return to documents",
    "resendOtpTitle": "Resend signing code (OTP)",
    "resendOtpDescription": "The code will be sent to the registered signer and, if added, also to the email provided below",
    "additionalEmailLabel": "Additional email (optional)",
    "emailPlaceholder": "Email",
    "resendOtpButton": "Resend OTP"
  },
  "errors": {
    "pageNotFound": "PAGE NOT FOUND",
    "backToHome": "Back to home",
    "weApologize": "WE APOLOGIZE!",
    "underMaintenance": "WE ARE TEMPORARILY UNDER MAINTENANCE",
    "somethingWentWrong": "SOMETHING WENT WRONG"
  },
  "toast": {
    "userNotFound": "User not found!",
    "accessDenied": "Access denied!",
    "emailInUse": "The email is already in use",
    "emailNeedsVerification": "The email needs to be verified!",
    "userDisabled": "User disabled.",
    "tokenNotFound": "Token confirmation not found.",
    "tokenExpired": "Token confirmation expired.",
    "incorrectCurrentPassword": "Incorrect current password.",
    "incorrectCredentials": "Incorrect credentials.",
    "unexpectedError": "An unexpected error occurred. Please try again later."
  },
  "validation": {
    "cpfRequired": "CPF is required to proceed.",
    "cpfLength": "CPF must contain 11 digits.",
    "cpfInvalid": "Invalid CPF. Please review the data.",
    "cnpjInvalid": "Invalid CNPJ",
    "passwordRequired": "Password is required to proceed.",
    "passwordRequiredMasc": "Password is required to proceed.",
    "requiredField": "Required field",
    "invalidBirthDate": "Invalid birth date",
    "cpfRequiredShort": "CPF is required.",
    "fullNameRequired": "Full name is required to proceed.",
    "emailInvalid": "Invalid email",
    "emailRequired": "Email is required to proceed",
    "emailsMustMatch": "Emails do not match.",
    "confirmEmailRequired": "Repeat email is required to proceed.",
    "confirmPasswordRequired": "Repeat password is required to proceed.",
    "cellphoneRequired": "Mobile phone is required to proceed",
    "cellphoneInvalid": "This is not a valid mobile phone number",
    "termsRequired": "To proceed, you must accept the Terms of Consent",
    "passwordsMustMatch": "Passwords do not match."
  },
  "password": {
    "requirements": "Password must contain:",
    "minMax": "8 to 16 characters",
    "uppercase": "UPPERCASE letters",
    "lowercase": "Lowercase letters",
    "digits": "Numbers",
    "special": "Special characters (@ ; # $ , . etc)",
    "required": "Password is required to proceed."
  },
  "fullName": {
    "invalidName": "This is not a valid name.",
    "requirements": "Full name must contain at least:",
    "firstName": "1 first name with 2 letters",
    "lastName": "1 last name with 2 letters",
    "otherNames": "Other name(s) with 2 or more letters",
    "noAbbreviation": "Do not abbreviate your name."
  },
  "document": {
    "cpfLabel": "CPF *"
  }
}
